class KlaviyoButton extends HTMLElement {
  constructor() {
    super();
    this.formId = this.dataset.formId;
  }

  connectedCallback() {
    if (!this.formId) {
      console.error('You must provide a form-id attribute to use this component');
      return;
    }

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', this.formId, () => {
    }]);
  }
}

customElements.define('klaviyo-button', KlaviyoButton);
